export var EXPORT;
(function (EXPORT) {
    EXPORT["CSV"] = "csv";
    EXPORT["XLSX"] = "xlsx";
})(EXPORT || (EXPORT = {}));
